export default "__VITE_ASSET__B68OATuI__"